import * as constants from '../constants/location.constants';
import { getCookie } from '@/utils/';

interface ILocation {
    city: string;
    state: string;
    lat: number;
    lng: number;
}

const defaultLocation: ILocation = {
    city: "Bengaluru",
    state: "Karnataka",
    lat: 12.9716,
    lng: 77.5946
};

const getInitialLocation = (): ILocation => {
    const cookieData = getCookie('user_location');

    if (cookieData) {
        try {
            return JSON.parse(cookieData);
        } catch (e) {
            console.error("Error parsing location cookie", e);
            return defaultLocation;
        }
    }
    
    return defaultLocation;
};

const initialState: ILocation = getInitialLocation();

export const locationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case constants.SET_LOCATION:
      return {
        ...action.payload,
      };

    default:
      return state;
  }
};
